import script from "./GptChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GptChart.vue?vue&type=script&setup=true&lang=js"

import "./GptChart.vue?vue&type=style&index=0&id=479b5509&lang=less&scoped=true"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479b5509"]])

export default __exports__